import { render } from "./ThankYouContact.vue?vue&type=template&id=35ce0524&scoped=true"
import script from "./ThankYouContact.vue?vue&type=script&lang=js"
export * from "./ThankYouContact.vue?vue&type=script&lang=js"

import "./ThankYouContact.vue?vue&type=style&index=0&id=35ce0524&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ce0524"]])

export default __exports__